import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Button, message, Col, Row } from "antd";
import PropTypes from "prop-types";
import API from "../../api";
const SupplierForm = ({ open, setOpen, selectedSupplier, onEdit }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);

  // Populate the form with selected supplier data or reset if none is selected
  useEffect(() => {
    if (selectedSupplier) {
      form.setFieldsValue({
        name: selectedSupplier.name,
        contactInfo: {
          phone: selectedSupplier.contactInfo?.phone,
          email: selectedSupplier.contactInfo?.email,
          address: {
            street: selectedSupplier.contactInfo.address?.street || "",
            city: selectedSupplier.contactInfo.address?.city || "",
            state: selectedSupplier.contactInfo.address?.state || "",
            pincode: selectedSupplier.contactInfo.address?.pincode || "",
          },
        },
        gstNumber:selectedSupplier.gstNumber || "",
        panNumber:selectedSupplier.panNumber || ""
      });
    } else {
      form.resetFields();
    }
  }, [selectedSupplier, form]);
  async function getCityState(pincode) {
    const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
    const data = await response.json();

    if (data[0].Status === "Success") {
      const postOffice = data[0].PostOffice[0];
      form.setFieldsValue({
        contactInfo: {
          address: {
            city: postOffice?.District || "",
            state: postOffice?.State || "",
          }
        }
      });
    } else {
      form.setFieldsValue({
        contactInfo: {
          address: {
            city: null,
            state: null,
          }
        }
      });
      message.error("PinCode not found")
    }
  }


  // Handle form submission
  const onFinish = async (values) => {
    setLoading(true);
    const payload = {
      name: values.name,
      contactInfo: {
        phone: values.contactInfo.phone,
        email: values.contactInfo.email,
        address: values.contactInfo.address,
      },
    };

    try {
      let response;
      if (selectedSupplier) {
        response = await API.put(`/suppliers/${selectedSupplier._id}`, values);
        message.success("Supplier updated successfully!");
      } else {
        response = await API.post("/suppliers", values);
        message.success("Supplier added successfully!");
      }
      onEdit(response.data); // Notify parent component about the change
      form.resetFields();
      setOpen(false); // Close the form drawer
    } catch (err) {
      console.error("Error saving supplier:", err);
      message.error(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title={selectedSupplier ? "Edit Supplier" : "Add Supplier"}
      width={500}
      placement="right"
      onClose={() => setOpen(false)}
      open={open}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Supplier Name"
          name="name"
          rules={[
            { required: true, message: "Please enter the supplier name!" },
          ]}
        >
          <Input placeholder="Supplier Name" />
        </Form.Item>
        <Form.Item
          label="Phone"
          name={["contactInfo", "phone"]}
          rules={[
            { required: true, message: "Please enter the phone number!" },
          ]}
        >
          <Input placeholder="Phone Number" />
        </Form.Item>
        <Form.Item
          label="Email"
          name={["contactInfo", "email"]}
          rules={[
            { required: true, message: "Please enter the email!" },
            { type: "email", message: "Please enter a valid email address!" },
          ]}
        >
          <Input placeholder="Email Address" disabled={selectedSupplier} />
        </Form.Item>
        {/* <Form.Item
          label="Address"
          name={["contactInfo", "address","street"]}
          rules={[{ required: true, message: "Please enter the address!" }]}
        >
          <Input placeholder="Supplier Address" />
        </Form.Item>
        <Form.Item>
        
 */}

        <Form.Item
          label="GST Number"
          name="gstNumber"
          rules={[
            { required: true, message: "Please enter the GST number!" },
            {
              pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/,
              message: "Please enter a valid GST number!",
            },
          ]}
        >
          <Input placeholder="GST Number" />
        </Form.Item>

        <Form.Item
          label="PAN Number"
          name="panNumber"
          rules={[
            { required: true, message: "Please enter the PAN number!" },
            {
              pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
              message: "Please enter a valid PAN number!",
            },
          ]}
        >
          <Input placeholder="PAN Number" />
        </Form.Item>


        <Form.Item label="Address">
          <Form.Item
            label="Street"
            name={["contactInfo", "address", "street"]}
            rules={[{ required: true, message: "Please enter the street!" }]}
            style={{ marginBottom: 8 }}
          >
            <Input placeholder="Enter your street address" />
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="City"
                name={["contactInfo", "address", "city"]}
                rules={[{ required: true, message: "Please enter the city!" }]}
                style={{ marginBottom: 8 }}
              >
                <Input placeholder="City will autofill based on pincode" disabled />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="State"
                name={["contactInfo", "address", "state"]}
                rules={[{ required: true, message: "Please enter the state!" }]}
                style={{ marginBottom: 8 }}
              >
                <Input placeholder="State will autofill based on pincode" disabled />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label="PinCode"
            name={["contactInfo", "address", "pincode"]}
            rules={[
              { required: true, message: "Please enter a pincode!" },
              { pattern: /^[0-9]{6}$/, message: "Pincode must be a 6-digit number!" },
            ]}
          >
            <Input
              placeholder="Enter your pincode"
              type="text"
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{6}$/.test(value)) {
                  getCityState(value); // Call function only if it's 6 digits
                }
              }}
            />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading} block>
            Save
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

// Prop type validation
SupplierForm.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  selectedSupplier: PropTypes.object,
  onEdit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SupplierForm;
